import {
  TextField,
  Button,
  Typography,
  Container,
  Box,
  Alert,
  InputAdornment,
  IconButton
} from "@mui/material";
import { useContext, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../utils/AuthContext";
import axios from "axios";
import Header from "../../components/Header";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function LoginB() {
  const navigate = useNavigate();
  const { userId } = useParams();
  const { loading, error, dispatch } = useContext(AuthContext);

  const [credidentials, setCredidentials] = useState({
    email: "",
    password: "",
  });

  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setCredidentials((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch({ type: "LOGIN_START" });

    try {
      const res = await axios.post(
        "https://api.komorotel.com/api/auth/login",
        credidentials,
        {withCredentials:true}
      );


      dispatch({ type: "LOGIN_SUCCESS", payload: res.data });

      navigate("/");

    } catch (err) {
      dispatch({ type: "LOGIN_ERROR", payload: err.response?.data });
    }
  };

  const sendVerificationMail = async () => {
    try {
      await axios.post(
        `https://api.komorotel.com/api/auth/sendVerificationMail/${userId}`
      );
      alert("Email de vérification renvoyé");
    } catch (err) {
      alert("Erreur lors de l'envoi");
    }
  };

  return (
    <>
      <Header disabled />

      <Container maxWidth="sm">
        <Box
          sx={{
            mt: 16,
            p: 5,
            borderRadius: 4,
            backgroundColor: "#fff",
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
          }}
        >

          {/* 🔥 TITLE */}
          <Typography variant="h4" fontWeight="bold" mb={1}>
            Vérifiez votre compte
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={3}>
            Un email de confirmation vous a été envoyé.  
            Connectez-vous après validation.
          </Typography>

          {/* 🔥 RESEND */}
          <Box
            sx={{
              mb: 3,
              p: 2,
              borderRadius: 2,
              backgroundColor: "#f9fafb",
              border: "1px solid #eee",
            }}
          >
            <Typography variant="body2" mb={1}>
              Vous n'avez pas reçu l'email ?
            </Typography>

            <Button
              onClick={sendVerificationMail}
              size="small"
              sx={{ color: "#3A9D23", fontWeight: 600 }}
            >
              Renvoyer l'email
            </Button>
          </Box>

          {/* 🔥 FORM */}
          <Box component="form" onSubmit={handleSubmit}>

            <TextField
              fullWidth
              label="Email"
              id="email"
              margin="normal"
              onChange={handleChange}
            />

            <TextField
              fullWidth
              label="Mot de passe"
              id="password"
              type={showPassword ? "text" : "password"}
              margin="normal"
              onChange={handleChange}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error.message || "Une erreur est survenue"}
              </Alert>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                py: 1.5,
                borderRadius: 2,
                backgroundColor: "#3A9D23",
                "&:hover": { backgroundColor: "#33891E" },
              }}
              disabled={loading}
            >
              {loading ? "Connexion..." : "Se connecter"}
            </Button>

          </Box>

        </Box>
      </Container>
    </>
  );
}